import React from 'react';
import PropTypes from 'prop-types';
import {trackEvent} from '../../../utils/tracking.js';
import '@fiverr/globals';
import './style.scss';

const Favorite = ({ isFavorited, user, toggleCollection, cardType, cardSize, gigId, sellerId }) => {
    const heartColor = isFavorited ? ' red' : '',
        hintClassTrue = cardType === 'list' ? 'hint--bottom-right ' : 'hint--top ',
        hintClass = !isFavorited ? hintClassTrue : '',
        hintText = !isFavorited ? i18n.t('collections.add_to_favorites') : null,
        onClick = (e) => {
            const payload = {
                collection: {
                    type: 'gig',
                    source: 'gig_card',
                    name: 'Gigs I Love'
                },
                user: {
                    id: user.userId
                },
                seller: {
                    id: sellerId
                },
                gig: {
                    id: gigId
                }
            };

            trackEvent(`heart-${!isFavorited ? 'collect' : 'uncollect'}`, cardType, cardSize);
            trackEvent(`collection_items.${!isFavorited ? 'create' : 'destroy'}`, cardType, cardSize, 'click', payload, 'bigquery');

            toggleCollection(e, 'Gigs I Love', isFavorited);
        };

    return (
        <a className={`${hintClass}icn-heart${user ? '' : ' js-open-popup-join'}`}
            href="#!"
            {...(hintText && {'data-hint': hintText})}
            data-gtm-action="hp-clicked-heart"
            data-gtm-event="collections"
            onClick={onClick}>
            <i className={`ficon ficon-favorite${heartColor}`}></i>
        </a>
    );
};

Favorite.propTypes = {
    isFavorited: PropTypes.bool,
    cardType: PropTypes.string,
    user: PropTypes.object,
    toggleCollection: PropTypes.func
};

export default Favorite;



// WEBPACK FOOTER //
// ./src/shared/collect_gig/favorite/index.js